module.exports = __webpack_public_path__ + "static/media/ProdigalTiger_Bookcover.a90ca795.jpg";